import React, { useState } from 'react';
import { QueryStatsIcon } from '@ui/icons';
import { CloseButton, Dialog, Typography } from '@ui/components';
import { clsx, makeStyles } from '@ui/styles';
import { IconButton } from '../../common/IconButton';
import { LicenseUsageChart } from './LicenseUsageChart';
import { UsageReportProvider } from './UsageReportContext';
import { TimeSpanSelect } from './TimeSpanSelect';
import { LicenseUsageTable } from './LicenseUsageTable';
import { LicenseActiveUsersTable } from './LicenseActiveUsersTable';

type Props = React.ComponentProps<typeof IconButton> & { licenseId: string };

export const UsageReportButton: React.FC<Props> = ({ licenseId, ...rest }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  return (
    <>
      <IconButton
        color='secondary'
        icon={<QueryStatsIcon />}
        onClick={() => setOpen(true)}
        {...rest}
      />

      <Dialog open={open} maxWidth='xl' fullWidth onClose={() => setOpen(false)}>
        <UsageReportProvider licenseId={licenseId}>
          <Dialog.Title>
            Usage Report
            <Typography>License ID {licenseId}</Typography>
            <CloseButton onClick={() => setOpen(false)} />
          </Dialog.Title>

          <Dialog.Content className={classes.controls}>
            <Typography variant='h5'>Usage Chart</Typography>

            <TimeSpanSelect />
          </Dialog.Content>

          <Dialog.Content className={classes.content}>
            <LicenseUsageChart />
          </Dialog.Content>

          <Dialog.Content className={clsx(classes.content, classes.tableContent)}>
            <LicenseUsageTable />

            <LicenseActiveUsersTable />
          </Dialog.Content>
        </UsageReportProvider>
      </Dialog>
    </>
  );
};

const useStyles = makeStyles({
  controls: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 0,
    flexShrink: 1,
    '& :first-child': { flexGrow: 1, alignSelf: 'center' },
    '& + * :first-child': { flexShrink: 1 },
  },
  content: {
    display: 'flex',
    flex: '1 1 50%',
  },
  tableContent: {
    '& > *': {
      flexGrow: 0,
      maxWidth: '50%',
      flexBasis: '50%',
    },
  },
});
